import { z } from "zod";
import { APP_PLATFORM_VALUES, type AppPlatform } from "../enum.js";

export interface AppVersion {
	platform: AppPlatform;
	latest_version: string;
	min_supported_version: string;
	updated_at: Date;
	updated_by: string | null;
}

const semverPattern = /^\d+\.\d+\.\d+$/;

export const upsertAppVersionSchema = z.object({
	latest_version: z.string().regex(semverPattern, { message: "Must be semver X.Y.Z" }),
	min_supported_version: z.string().regex(semverPattern, { message: "Must be semver X.Y.Z" }),
});

export type UpsertAppVersionPayload = z.infer<typeof upsertAppVersionSchema>;

export const appVersionPlatformParamSchema = z.object({
	platform: z.enum(APP_PLATFORM_VALUES),
});

export type AppVersionPlatformParam = z.infer<typeof appVersionPlatformParamSchema>;
